import React from 'react';
import GameRadio from './DomGameRadio';
import inv from '../images/imgLinks/invadersLink1.png';
import seas from '../images/imgLinks/seasonsLink2.png';
import fishTankLink from '../images/imgLinks/fishtankLink1.png';

const JavascriptProjects = ()=> {
    
    return (
        <div className="projects">
            <h2>Canvas and DOM Games</h2>
            <hr />
            <div className='projectTile'>
                <p>The canvas games below were created using the p5/processingJS library.&nbsp; Clicking the images will open a new tab, since I'm not quite sure yet how/if I can run p5 through a react page. &nbsp; They were fun to make and I enjoyed figuring out how to handle animations, object collisions, parallax effects and a variety of other things that popped up as I continued to add functionality.&nbsp; While I'm currently focused on a wider variety web dev skills, I think canvas elements are underused and underestimated, and I absolutely want to create more canvas games and flesh out the existing ones some more in the future.&nbsp; <b>Seasons</b> started as a spin-off of a Khan Academy project by <a href="https://www.khanacademy.org/computer-programming/seasons-the-game/5900023699079168">Ryan Kee</a>.&nbsp; Sound files are from <a href="https://freesound.org/">FreeSound.org</a> <span className="sans">(</span>as named and/or credited<span className="sans">)</span>.&nbsp; Sprites were created with GIMP and ArtStudio.</p>
            </div>
            <div className="flexToCol600">  
                <div className="border-hover">
                    <a href="https://aerinkayne.github.io/invaders.html" target="_blank" rel="noopener noreferrer">
                        <img id="invadersImg" src={inv} alt="a canvas space invaders type shooter game" title="Space Invaders"/>
                    </a>
                </div>
                <div className="border-hover">
                    <a href="https://aerinkayne.github.io/seasons_p5.html" target="_blank" rel="noopener noreferrer">
                        <img id="seasonsImg" src={seas} alt="a canvas platform game based on a Khan Academy project by Ryan Kee" title="Seasons (Khan Academy Spin-Off project based on 'Seasons' by Ryan Kee)"/>
                    </a>
                </div>
                
            </div>
            

            <div className='projectTile'>
                <p>The DOM games below were guided by <a href="https://www.youtube.com/channel/UC5DNytAJ6_FISueUfzZCVsw">Ania Kubów's</a> tutorials on her YouTube channel. &nbsp;I made a number of style and code modifications, and I was super happy to be able to contribute some JS code for her Tetris project <span className="sans">(</span>see the html source of the <a href="https://aerinkayne.github.io/freeCodeCampProjects/tetris/index.html">older site</a> for the list of changes<span className="sans">)</span>.&nbsp; Use the buttons to select a game.</p>
            </div>

            
            <GameRadio />
            
            
            <br />
            
            
            <h2>D3 and React</h2>
            <hr />
            <div className='projectTile'>
                <p>Below are some D3 projects, and a set of small React projects, mostly created for <a href="https://www.freecodecamp.org/learn">FreeCodeCamp's</a> Data Visualization and Front End Library certifications. &nbsp;I also made a chart visualization of covid hospitalizations from data available through the ECDC.&nbsp; I have a number of other projects that can be viewed at my <a href="https://www.freecodecamp.org/aerin">FCC profile page</a> as well <span className="sans">(</span>I wanted to limit the number of coursework related projects here<span className="sans">)</span>.&nbsp; Currently, all of these will open in a new tab, and are associated with their own GH repos.</p>
            </div>
                {/*<a  className="projectLink" href="https://aerinkayne.github.io/europe_hosp_data/" target="_blank" rel="noopener noreferrer">D3 Covid Hospitalizations
                </a>*/}
                <a  className="projectLink" href="https://aerinkayne.github.io/bar_chart_project/treemap/" target="_blank" rel="noopener noreferrer">FCC D3 Treemap Project 
				</a>
                <a  className="projectLink" href="https://aerinkayne.github.io/bar_chart_project/choropleth/" target="_blank" rel="noopener noreferrer">FCC D3 Choropleth Map
				</a>
                <a  className="projectLink" href="https://aerinkayne.github.io/react_projects/#/" target="_blank" rel="noopener noreferrer">FCC React projects   
				</a>
			
            <br />
            {/*
            <h2>Other Projects</h2>
            <hr />
            <div className='projectTile'>
                <a className="projectLink" href="https://shrouded-hamlet-44646.herokuapp.com/" target="_blank" rel="noopener noreferrer">Weather App using OpenWeather API.</a>
            </div>
            
            <hr className="shortHR" />
            <div className='projectTile'>
                <a className="projectLink" href="https://glacial-lake-89796.herokuapp.com/" target="_blank" rel="noopener noreferrer">Blog using Express, MongoDB, and AWS on heroku</a>
                <p className="leftText">This was created primarily through <a href="https://www.amazon.com/Beginning-Node-js-Express-MongoDB-Development/dp/1078379556">'Beginning Node.js, Express, and MongoDB Development'</a> by <b>Greg Lim</b>. &nbsp;I was able to add search functionality after looking into how to query documents with form data, but generally this was a very guided project.&nbsp; It was a great intro to some of Node's built-ins <span className="sans">(</span>http, fs, path, util<span className="sans">)</span> as well as several npm packages <span className="sans">(</span>mongoose, express, express-session, body-parser, bcrypt, and the EJS templating engine<span className="sans">)</span>.</p>
            </div>*/}
            <hr className="shortHR" />
            <div className='projectTile'>
                
				<a href="https://aerinkayne.github.io/fishtank.html" target="_blank" rel="noopener noreferrer">
				<img id="fishtankImg" src={fishTankLink} alt="a canvas fishtank" title="Interactive Fishtank Canvas Element" />
				</a>
                
			</div>
            
        </div>
    );
};

export default JavascriptProjects;